export const BRAND_GLOBAL_VARIABLE = '__USER_DOMAIN_BRAND__'
